import store from "fragments/vendors/store"
import { gql } from "graphql-tag"

const GET_STORES = gql`
  ${store}

  query getStores($query: GetQueryStores) {
    getStores(query: $query) {
      ...Store
    }
  }
`

export default GET_STORES
